import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    Output,
    EventEmitter,
    Input,
    ViewChild,
    Renderer2,
    HostListener, ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {StocksService} from 'app/stocks/services/stocks.service';
import {CommonDataService} from 'app/services/common-data.service';
import {StocksFilterService} from "app/stocks/services/stocks-filter.service";
import {ISubscription} from "rxjs/Subscription";
//import {StocksHelper} from "../../models/stocks-helper";
import {ChartHelper} from "app/buffer-graph/models/chart-helper";
import {CodeName} from "../../../stocks/models/code-name";
import {Formatters} from "../../../slick-grid/models/formatters";
import {BufferGraphService} from "../../services/buffer-graph.service";
import {SlickGridComponent} from "../../../slick-grid/slick-grid.component";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import {ChartListProps} from "../../models/amchart/chart-list-props";
import * as Popper from 'popper.js/dist/umd/popper';
import {CompareItem} from "../../models/compare-item";
import {CommonService} from "../../../services/common.service";
// import {StocksPreset} from "../../models/stocks-preset";
// import {PresetHotKey} from "../../models/preset-hot-key";

@Component({
    selector: 'code-name-list',
    templateUrl: './code-name-list.component.html',
    styleUrls: ['./code-name-list.component.css']
})
export class CodeNameListComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                private readonly stocksService: StocksService,
                public readonly commonData: CommonDataService,
                public readonly commonService: CommonService,
                private dataExchange: BufferGraphDataExchangeService,
                private filterService: StocksFilterService){

        this.selectionModel = new Slick.RowSelectionModel<CodeName, Slick.Range[]>({selectActiveRow: false});
        this.gridView = new Slick.Data.DataView<CompareItem>();

        this.columns = [
            {id: 'code', field: 'code', name: 'Code', sortable: true, width: 70},
            {id: 'name', field: 'name', name: 'Name', sortable: true, width: 220}
        ];

        this.options = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            autoEdit: false,
            enableAsyncPostRender: true,
        };

        this.helper = new ChartHelper();
        this.hide = new EventEmitter<boolean>();
        this.loadingOutput = new EventEmitter<boolean>();
        this.dataOutput = new EventEmitter<{ filterName: string, data: CompareItem }>();
        this.initialise();
    }

    private initialise = (): void =>{
        this.selected = null;
        this.timeOut = null
    };

    @HostListener('window:mouseup', ['$event']) onMouseUp(e: MouseEvent){
        if (this.mouseDown){
            this.mouseDown = false;
            this.resizeGrid(true)
        }
    }

    @Input() private GUID: string;
    @Input() public name: string;
    @Input() private filterName: string;
    @Input() private code?: string;
    @Input() private data?: CompareItem[];
    @Input() private addRef: ElementRef;
    @Input() private wrpRef: ElementRef;

    @Output()
    private readonly hide: EventEmitter<boolean>;

    @Output()
    private readonly loadingOutput: EventEmitter<boolean>;

    @Output()
    private readonly dataOutput: EventEmitter<{ filterName: string, data: CompareItem }>;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('gridWrpEl')
    private gridWrpEl: ElementRef;

    @ViewChild('grid')
    private grid: SlickGridComponent;

    private readonly gridView: Slick.Data.DataView<CompareItem>;
    private readonly columns: Slick.Column<CompareItem>[];
    private readonly options: Slick.GridOptions<CompareItem>;
    private readonly selectionModel: Slick.RowSelectionModel<CompareItem, Slick.Range[]>;
    private cellCssStyles: { [key: string]: Slick.CellCssStylesHash };
    public _loading: boolean;
    private helper: ChartHelper;
    private subscriptionMouseMove: ISubscription;
    private popperAddVar: Popper;
    private listenMouseDown: () => void;
    // private data: CompareItem[];
    private selected: CompareItem;
    private filteredData: CompareItem[];
    private searchData: string;
    private mouseDown: boolean;
    private timeOut: any;
    private showActivity: boolean;
    public outline: boolean;

    // private listenContextMenu: () => void;


    async ngOnInit(){

        // this.listenContextMenu = this.renderer.listen('body', 'contextmenu', (e: MouseEvent) => this.hideList(e));
        this.listenMouseDown = this.renderer.listen('body', 'mousedown', (e: MouseEvent) => this.hideList(e));
        this.subscriptionMouseMove = this.commonService.mouseMoveCurrent.subscribe(e => {
            // console.log(this.commonService.count, 'subscriptionMouseMove');
            this.helper.tryCatch(() => e && this.mouseDown && this.resizeGrid())
        });

        if (this.data){
            this.showActivity = true;
            this.columns.unshift({id: 'active', field: 'active', name: 'Stocks_WrhActive', sortable: true, width: 35});
            this.filteredData = this.data = this.data.map(item => new CompareItem(item.itemId, item.active, item.balanceStatus, item.code, item.name));
            this.gridView.setItems(this.filteredData);
            //this.setCellStyles();
        } else{
            await this.loadData();
        }

        this.resizeGrid(true);
        this.setCellStyles();

        // this.subscriptionUpdateHotKeys = this.filterService.updateHotKeysCurrent.subscribe(res => this.updateButtons(res));
    }

    ngOnDestroy(){
        // this.listenContextMenu();
        this.listenMouseDown();
        // this.subscriptionUpdateHotKeys.unsubscribe();
    }

    ngAfterViewInit(){
        // this.grid.resizeGrid();

        this.popperAdd();
    }

    //# loading data and set it to list
    private loadData = async (): Promise<void> =>{
        this.loading = true;
        let chartListProp: ChartListProps = this.dataExchange.getChartListProps().find(item => item.GUID === this.GUID);
        if (!chartListProp){
            return;
        }

        let data;
        try{
            data = await this.filterService.GetDataForCodeNameFilter(this.filterName, chartListProp.filter).toPromise();
        } catch (e){
            this.helper.showError(e, () => console.error(e));
        }


        // .subscribe(data => {
        this.helper.wait(() => this.loading = false);
        if (!data){

            this.translateService.get('GetCodeNameDataError')
                .subscribe(error => this.commonData.showErrors([error]));
            return;
        }

        this.data = data.map(item => new CompareItem(item.id, '', null, item.code, item.name));
        this.data.forEach(d => d.selected = d.code === this.code);
        this.code && this.data.sort( (a: CompareItem, b: CompareItem) =>  a.code === this.code ? -1 : b.code === this.code ? 1 : 0);
        this.filteredData = this.data;

        this.gridView.setItems(this.filteredData);
        // console.log(data, 'code name data');
        // console.log(chartListProp.filter, 'GetDataForCodeNameFilter');
        // console.log(data.length, 'GetDataForCodeNameFilter');
        // })
    }

    //# after click on grid apply selected
    public onGridClick = (args: any): void =>{
        let data = this.gridView.getItem(args.data.row),
            el = args.event.target,
            row = args.data.row;
        this.grid.setSelectedRows([row]);
        this.selected = this.gridView.getItem(row);
        this.selected ? this.apply('Apply') : null;

    };

    //# after double click on grid apply selected
    public onGridDblClick = (args: any): void =>{
        //this.onGridClick(args);
        this.selected ? this.apply('Apply') : null;
    };

    //# enable loading image in inform about it parent component
    set loading(val: boolean){
        if (val !== this._loading){
            this._loading = val;
            this.helper.wait(() => this.loadingOutput.emit(val));

        }
    }

    get loading(): boolean{
        return this._loading;
    }

    //# add popper for component
    public popperAdd = (): void =>{

        this.popperAddVar = new Popper(this.addRef && this.addRef.nativeElement ? this.addRef.nativeElement : this.addRef, this.mainWrapper.nativeElement.parentElement, {
            placement: 'right-start',
            modifiers: {
                flip: {
                    behavior: ['right-start']
                },
                preventOverflow: {
                    boundariesElement: this.wrpRef,
                },
            },
        });
    };

    //# hide this component
    private hideList = (e: MouseEvent): void =>{
        this.mouseDown = true;
        if (this.helper.hideList(this.mainWrapper, e, this.renderer)){
            this.helper.wait(() => this.hide.emit(true), 50);
        }
    };

    //# search in list
    public filterSearch = (e?: KeyboardEvent, keyDown?: boolean): void =>{

        if (e && (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 17 || e.keyCode === 18)) return;

        if (e && e.keyCode === 27 && !keyDown){
            return;
        }

        if (e && e.keyCode === 9 && this.loading){
            e.preventDefault();
            return;
        }

        if (e && e.keyCode === 9 && e.repeat){
            e.preventDefault();
            return;
        }

        let data: string[] = [];
        if (this.searchData && !keyDown){
            data = this.searchData.split(' ').map(item => item.trim());
        }

        if (this.data && this.data.length > 0 && !keyDown){

            if (this.searchData && this.searchData.length > 0){
                this.filteredData = this.data.filter(item =>{
                    item.findCode = this.helper.matchText(data, item.code);
                    item.findName = this.helper.matchText(data, item.name);
                    return item.findCode || item.findName;
                });
            } else{
                this.data.forEach(item =>{
                    item.findCode = false;
                    item.findName = false;
                });
                this.filteredData = this.data;
            }

            this.gridView.setItems([]);
            this.gridView.setItems(this.filteredData);

            this.columnWidth();
            this.setCellStyles();
        }
    };

    //# set color for grid sells
    private setCellStyles = (): void =>{
        let mainStyles = null;

        this.filteredData.forEach((row: CompareItem, i: number) => mainStyles = this.setCellMainStyles(mainStyles, row, i));
        const styles = {};
        if (mainStyles === null) mainStyles = {};
        styles['main-styles'] = mainStyles;
        this.cellCssStyles = styles;

    };

    //# generate colors for grid sells on row
    private setCellMainStyles = (hash: Slick.CellCssStylesHash, row: CompareItem, index: number): Slick.CellCssStylesHash =>{
        let styles = null;

        if (row.findCode)
            styles = Object.assign({}, {code: 'found'});

        if (row.findName)
            styles = Object.assign(styles || {}, {name: 'found'});

        if (row.selected)
            styles = Object.assign(styles || {}, {name: 'selected', code: 'selected'});

        if (this.showActivity){
            styles = Object.assign(styles || {}, {active: this.getCompareItemBalanceClass(row)});
        }

        if (!styles)
            return hash;

        if (!hash)
            hash = {};
        hash[index] = styles;

        return hash;
    };

    //# get classname for balance status
    private getCompareItemBalanceClass = (item: CompareItem): string =>{
        switch (item.balanceStatus){
            case 1:
                return 'compare-balance-zero';
            case 2:
                return 'compare-balance-safetystock';
            case 3:
                return 'compare-balance-red';
            case 4:
                return 'compare-balance-yellow';
            case 5:
                return 'compare-balance-green';
            case 6:
                return 'compare-balance-overstock';
            default:
                return '';
        }
    }

    //# apply selection
    public apply = (command: string): void =>{

        if (this.selected){
            switch (command){
                case 'Apply':
                    this.dataOutput.emit({filterName: this.filterName, data: this.selected});
                    break;
            }
        }
        this.hide.emit(true);
    };

    //# resize grid when dimensions of wrapper changing
    public resizeGrid = (last?: boolean): void =>{
        if (this.grid && this.mouseDown){
            if (this.timeOut){
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }

            this.timeOut = setTimeout(() =>{
                //this.columnWidth();
                this.grid.resizeGrid();
                clearTimeout(this.timeOut);
                this.timeOut = null;
            }, 100);
        } else if (this.grid && last){
            this.helper.wait(() => this.columnWidth());
        }
    };

    //# recalculate grid column width when dimensions of wrapper changing
    private columnWidth = (): void =>{
        if (!this.gridWrpEl || !this.grid){
            return;
        }

        let slickScrollWidth = 12,
            width = this.gridWrpEl.nativeElement.offsetWidth - 2,
            gridHeight = this.gridWrpEl.nativeElement.offsetHeight;
        let stringQuantity = Math.floor((gridHeight - 5) / 25) - 1;
        if (this.filteredData.length > stringQuantity){
            width = width - slickScrollWidth;
        }
        this.columns.forEach(item =>{
            if (item.field !== 'name'){
                width = width - item.width;
            }
        });

        this.columns.forEach(item =>{
            if (item.field === 'name' && width > 100){
                item.width = width;
            }
        });

        this.grid.setColumns(this.columns);
        this.grid.resizeGrid();
    }
}




// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/code-name-list.component/code-name-list.component.ts